<template>
  <ModalConfirmAction
    title="Excluir colaboração"
    message="Tem certeza que deseja remover a colaboração?"
    :loading="loading"
    @confirm="removerColaboracao(colaboracao.id_colaboracao, colaboracao.cod_producao)"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div class="card-action-box card-action-box--delete" v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }" role="button" aria-label="Excluir">
        <v-icon>mdi-delete-outline</v-icon>
      </div>
        </template>
        <span>Excluir</span>
      </v-tooltip>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    colaboracao: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      cod_pasta: 'pastas/getterCodPasta'
    })
  },
  methods: {
    ...mapActions({
      getColaboracoesAprovadas:
        "colaboracoes_aprovadas/getColaboracoesAprovadas",
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas"
    }),
    async removerColaboracao(id, cod_producao) {
      try {
        this.loading = true;

        const flg_favorita = JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) || false
        const flg_exibida = JSON.parse(localStorage.getItem("@socialcam/flg_exibida")) || false

        const payload = {
          dsc_login_usuario: this.$store.getters["users/username"],
          cod_producao,
        };

        const response = await apiClient.patch(
          `/removerColaboracao/${id}`,
          payload
        );

        const page = flg_exibida ? this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_exibidas.currentPage
                      : flg_favorita ? this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_favoritas.currentPage
                      : this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas.currentPage
        if (response.status === 200) {
          await this.getColaboracoesAprovadas({
            page,
            size: 5,
            cod_producao: JSON.parse(
              localStorage.getItem("@socialcam/selected_option_production")
            ),
            flg_favorita:
              JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) ||
              false,
            filtros:
              JSON.parse(localStorage.getItem("@socialcam/filtros")) || [],
            filtro_texto: localStorage.getItem("@socialcam/filtro_texto") || "",
            flg_exibida,
            cod_pasta: this.cod_pasta
          });
          this.setCopyColaboracoesRecebidas(this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas)
          this.$toast.success("Colaboração removida com sucesso");
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Não foi possível excluir colaboração.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.deleteButton1 {
  background: var(--v-surface_neutral_selected-base) !important;
}
</style>
